import { Grid } from '@mui/material';
import { FC, useState } from 'react';
import {
  NeighborhoodLotsDropdown,
  FiltersButtons,
  FiltersLayout,
  SearchField,
  SalesStatusAutoComplete
} from '../../../components';
import { SalesNeighborhoodDropdown } from '../../../components/dropdowns/sales-neighborhood-dropdown';

interface IContractAcceptanceFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  selectedLotId: string;
  setSelectedNeighborhoodId: (val: any) => void;
  setSelectedLotId: (val: any) => void;
  selectedNeighborhoodId: string;
  setSelectedStatuses?: (val: any) => void;
  selectedStatuses?: string[];
  setSearchedValue?: (val: string) => void;
  searchedValue?: string;
  setSearchValue?: (val: string) => void;
  searchValue?: string;
  handleSearch?: (val: string) => void;
  searchPlaceholder?: string;
  hasAppliedFiltersGlobal?: boolean;
}

export const ContractAcceptanceFilters: FC<IContractAcceptanceFilters> = ({
  isLoading,
  applyFilters,
  selectedNeighborhoodId,
  selectedLotId,
  setSelectedNeighborhoodId,
  setSelectedLotId,
  setSearchValue,
  searchValue,
  handleSearch,
  searchPlaceholder,
  setSelectedStatuses,
  selectedStatuses,
  setSearchedValue,
  searchedValue,
  hasAppliedFiltersGlobal
}) => {
  const [hasAppliedFilters, setHasAppliedFilters] = useState<boolean>(hasAppliedFiltersGlobal);

  return (
    <FiltersLayout>
      {handleSearch && (
        <Grid item xs={12} sm={6} md={6} xl={6}>
          <SearchField
            isDisabled={isLoading}
            placeholder={searchPlaceholder}
            handleSearch={() => {
              setHasAppliedFilters(true);
              applyFilters();
              handleSearch(searchValue);
            }}
            handleClearSearch={() => {
              setSearchValue('');
              handleSearch('');
            }}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6} md={6} lg={6}>
        <SalesNeighborhoodDropdown
          value={selectedNeighborhoodId}
          handleChange={value => {
            setSelectedNeighborhoodId(value);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6}>
        <NeighborhoodLotsDropdown
          value={selectedLotId}
          isDisabled={!selectedNeighborhoodId}
          handleChange={value => setSelectedLotId(value)}
          apiParams={{ neighborhoodId: selectedNeighborhoodId }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6}>
        <SalesStatusAutoComplete
          isDisabled={isLoading}
          value={selectedStatuses}
          handleChange={value => {
            setSelectedStatuses(value);
          }}
          handleClear={() => {
            setSelectedStatuses([]);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSelectedNeighborhoodId('');
            setSelectedLotId('');
            setSelectedStatuses([]);
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};
